import type { TCurrentPropertyRange, TPortfolio } from '@dekafvv/sharedfrontend';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialTopUpState } from './data';
import type {
    TAllocation, TAnswers, TExAnteTopUp, TFees, TValidations,
} from './types';

const initialState = initialTopUpState;

export const topUpSlice = createSlice({
    name: 'topUp',
    initialState,
    reducers: {
        setAnswers: (state, action: PayloadAction<Partial<TAnswers>>) => ({
            ...state,
            answers: {
                ...state.answers,
                ...action.payload,
            },
        }),
        setTopUpPortfolio: (state, action: PayloadAction<TPortfolio>) => ({
            ...state,
            portfolio: {
                ...action.payload,
            },
        }),
        setExAnteTopUp: (state, action: PayloadAction<TExAnteTopUp>) => ({
            ...state,
            exAnteTopUp: action.payload,
        }),
        setTopUpFees:
            (state, action: PayloadAction<TFees>) => ({
                ...state,
                fees: action.payload,
            }),
        setTopUpAllocations:
            (state, action: PayloadAction<TAllocation[]>) => ({
                ...state,
                allocations: action.payload,
            }),
        setTopUpValidations:
            (state, action: PayloadAction<TValidations>) => ({
                ...state,
                validations: action.payload,
            }),
        setCurrentProperty: (state, action: PayloadAction<number | null>) => ({
            ...state,
            currentProperty: action.payload,
        }),
        setCurrentPropertyRange: (state, action: PayloadAction<TCurrentPropertyRange | null>) => ({
            ...state,
            currentPropertyRange: action.payload,
        }),
        setInitialTopUpState: () => initialState,
    },
});
